import { render } from "./CustomCombobox.vue?vue&type=template&id=ec2566fc&scoped=true&ts=true"
import script from "./CustomCombobox.vue?vue&type=script&lang=ts"
export * from "./CustomCombobox.vue?vue&type=script&lang=ts"

import "./CustomCombobox.vue?vue&type=style&index=0&id=ec2566fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2566fc"]])

export default __exports__